import React,{useState} from "react";
import AppContext from "./Context/AppContext";
import { BrowserRouter,Switch, Route } from "react-router-dom";
import Carta from "./Pages/Carta";
import Pedidosya from "./Pages/Pedidosya";
import Delivery from "./Pages/Delivery";
import Login from "./Pages/Login";
import QR from "./Pages/QR";
import NotFound from "./Pages/NotFound";
import Lista from "./Pages/Lista";
import CustomerStatus from "./Contents/Lista/CustomerStatus";
import CustomerCancel from "./Contents/Lista/CustomerCancel";
import ListaAdmin from "./Pages/Admin/ListaAdmin";
import Configuracion from "./Pages/Admin/Configuracion";
import Reservas from "./Pages/Admin/Reservas";
import DeliveryAdmin from "./Pages/Admin/DeliveryAdmin";
import NewItem from "./Pages/Admin/Menu/NewItem";
import Menu from "./Pages/Admin/Menu";
import Cantidad from "./Contents/Lista/Cantidad";
import Nombre from "./Contents/Lista/Nombre";
import Telefono from "./Contents/Lista/Telefono";
import Confirmado from "./Contents/Lista/Confirmado";
import Nota from "./Contents/Lista/Nota";
import Variables from "./Pages/Admin/Menu/Variables";
import Home from "./Pages/Home"
import Reseña from "./Pages/Reseña";
import Reseñas from "./Pages/Admin/Reseñas";




const App=()=>
{
    const [Logged, setLogged]= useState(false);
    const [Customer, setCustomer] = useState
    ({
        count:undefined,
        name:"",
        phone:"",
        note:"",
        docID:"",
    })
  
    
    return( <AppContext.Provider value={{Logged,setLogged ,Customer, setCustomer}}>
        <BrowserRouter>
        <Switch>
            <Route  exact path="/" component={Home}/>
            <Route  exact path="/carta" component={Carta}/>
            <Route  exact path="/reseña" component={Reseña}/>
            <Route  exact path="/pedidosya" component={Pedidosya}/>
            <Route  exact path="/delivery" component={Delivery}/>
            <Route  exact path="/login" component={Login}/>
            <Route  exact path="/admin" component={ListaAdmin}/>
            <Route  exact path="/admin/menu" component={Menu}/>
            <Route  exact path="/admin/menu/:categoria/:id/variables" component={Variables}/>
            <Route  exact path="/admin/menu/nuevo" component={NewItem}/>
            <Route  exact path="/admin/delivery" component={DeliveryAdmin}/>
            <Route  exact path="/admin/reservas" component={Reservas}/>
            <Route  exact path="/admin/configuracion" component={Configuracion}/>
            <Route  exact path="/admin/reseñas" component={Reseñas}/>
            <Route  exact path="/lista" component={Lista}/>
            <Route  exact path="/lista/cantidad" component={Cantidad}/>
            <Route  exact path="/lista/nombre" component={Nombre}/>
            <Route  exact path="/lista/telefono" component={Telefono}/>
            <Route  exact path="/lista/nota" component={Nota}/>
            <Route  exact path="/lista/confirmado" component={Confirmado}/>
            <Route  exact path="/lista/:id" component={CustomerStatus}/>
            <Route  exact path="/lista/:id/cancelar" component={CustomerCancel}/>
            <Route  exact path="/qr" component={QR}/>
            <Route  exact path="*" component={NotFound}/>
        </Switch>
    </BrowserRouter>
    </AppContext.Provider>);
}

export default App;